"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.symbol");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = WalletDownload;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _useBrowser = _interopRequireDefault(require("@arcblock/react-hooks/lib/useBrowser"));

var _Button = _interopRequireDefault(require("../Button"));

var _Util = require("../Util");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var AppStoreIcon = function AppStoreIcon(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("title", null, "Appstore"), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M.198 3.792v42.064a3.594 3.594 0 0 0 3.595 3.594h164.414a3.594 3.594 0 0 0 3.595-3.594V3.792a3.594 3.594 0 0 0-3.595-3.594H3.793A3.594 3.594 0 0 0 .198 3.792z",
    fill: "#000",
    fillRule: "nonzero"
  }), _react["default"].createElement("path", {
    d: "M65.788 38.665h2.924l-6.402-17.73H59.35l-6.402 17.73h2.826l1.634-4.706h6.759l1.622 4.706zm-5.1-14.512h.21l2.567 7.496h-5.357l2.58-7.496zm15.778.91c-1.818 0-3.391.91-4.202 2.433h-.197v-2.212h-2.543v17.719h2.642v-6.365h.209c.7 1.413 2.211 2.248 4.116 2.248 3.38 0 5.53-2.666 5.53-6.918 0-4.251-2.15-6.905-5.555-6.905zm-.75 11.452c-2.21 0-3.6-1.745-3.6-4.534 0-2.802 1.39-4.547 3.613-4.547 2.237 0 3.576 1.708 3.576 4.534 0 2.839-1.34 4.547-3.588 4.547zm14.452-11.452c-1.819 0-3.391.91-4.202 2.433h-.197v-2.212h-2.544v17.719h2.642v-6.365h.21c.7 1.413 2.211 2.248 4.116 2.248 3.379 0 5.529-2.666 5.529-6.918 0-4.251-2.15-6.905-5.554-6.905zm-.75 11.452c-2.211 0-3.6-1.745-3.6-4.534 0-2.802 1.389-4.547 3.613-4.547 2.236 0 3.575 1.708 3.575 4.534 0 2.839-1.339 4.547-3.588 4.547zm11.896-2.617c.197 3.17 2.839 5.197 6.771 5.197 4.202 0 6.832-2.125 6.832-5.517 0-2.666-1.5-4.14-5.136-4.989l-1.954-.479c-2.31-.54-3.244-1.266-3.244-2.531 0-1.598 1.45-2.642 3.625-2.642 2.064 0 3.49 1.02 3.748 2.654h2.678c-.16-2.986-2.789-5.087-6.39-5.087-3.87 0-6.45 2.101-6.45 5.26 0 2.604 1.462 4.152 4.669 4.902l2.286.553c2.346.553 3.379 1.364 3.379 2.716 0 1.572-1.622 2.715-3.834 2.715-2.372 0-4.018-1.069-4.252-2.752h-2.728zm15.877-11.858v3.305h-2.2v2.224h2.2v7.557c0 2.58 1.167 3.613 4.104 3.613.516 0 .995-.061 1.413-.135v-2.2c-.368.037-.577.062-.983.062-1.315 0-1.892-.615-1.892-2.015v-6.882h2.998v-2.224h-2.998V22.04h-2.642zm12.19 14.536c-2.298 0-3.588-1.683-3.588-4.608 0-2.9 1.29-4.595 3.588-4.595 2.286 0 3.588 1.696 3.588 4.595 0 2.913-1.302 4.608-3.588 4.608zm0 2.347c3.908 0 6.304-2.617 6.304-6.955 0-4.313-2.409-6.942-6.304-6.942-3.907 0-6.316 2.63-6.316 6.942 0 4.338 2.396 6.955 6.316 6.955zm7.509-.258h2.642v-7.9c0-1.88 1.413-3.146 3.403-3.146.443 0 1.254.086 1.463.16v-2.606c-.283-.073-.787-.11-1.168-.11-1.745 0-3.22.958-3.6 2.273h-.197v-2.052h-2.543v13.381zm13.456-11.39c1.953 0 3.231 1.363 3.293 3.465h-6.759c.148-2.09 1.512-3.465 3.466-3.465zm3.28 7.778c-.491 1.044-1.585 1.622-3.182 1.622-2.114 0-3.478-1.487-3.564-3.834v-.148h9.45v-.921c0-4.203-2.249-6.746-5.972-6.746-3.773 0-6.169 2.715-6.169 6.992 0 4.276 2.347 6.905 6.181 6.905 3.06 0 5.198-1.474 5.8-3.87h-2.544zM55.423 7.094v8.443h3.048c2.516 0 3.973-1.55 3.973-4.248 0-2.656-1.468-4.195-3.973-4.195h-3.048zm1.31 1.193h1.592c1.75 0 2.785 1.112 2.785 3.02 0 1.936-1.018 3.037-2.785 3.037h-1.592V8.287zm10.323 6.255c-1.094 0-1.708-.801-1.708-2.194 0-1.38.614-2.188 1.708-2.188 1.089 0 1.709.807 1.709 2.188 0 1.387-.62 2.194-1.709 2.194zm0 1.118c1.861 0 3.002-1.246 3.002-3.312 0-2.054-1.147-3.306-3.002-3.306-1.86 0-3.007 1.252-3.007 3.306 0 2.066 1.14 3.312 3.007 3.312zM79.92 9.165H78.66l-1.136 4.863h-.099l-1.31-4.863H74.91l-1.31 4.863h-.094l-1.141-4.863h-1.276l1.755 6.372h1.294l1.31-4.693h.1l1.316 4.693h1.305l1.75-6.372zm1.598 6.372h1.258V11.81c0-.995.62-1.615 1.633-1.615.936 0 1.392.509 1.392 1.533v3.81h1.258v-4.126c0-1.515-.801-2.37-2.223-2.37-.96 0-1.703.427-2.013 1.135h-.094V9.165h-1.21v6.372zm7.667 0h1.258V6.678h-1.258v8.86zm6.133-.995c-1.094 0-1.709-.801-1.709-2.194 0-1.38.615-2.188 1.709-2.188 1.088 0 1.708.807 1.708 2.188 0 1.387-.62 2.194-1.708 2.194zm0 1.118c1.86 0 3.002-1.246 3.002-3.312 0-2.054-1.147-3.306-3.002-3.306-1.86 0-3.008 1.252-3.008 3.306 0 2.066 1.141 3.312 3.008 3.312zm6.894-1.077c-.685 0-1.182-.333-1.182-.907 0-.561.398-.86 1.276-.918l1.556-.1v.533c0 .79-.702 1.392-1.65 1.392zm-.322 1.06c.837 0 1.533-.363 1.913-1.001h.1v.895h1.211v-4.353c0-1.346-.9-2.142-2.498-2.142-1.446 0-2.475.702-2.604 1.797h1.217c.14-.451.626-.708 1.328-.708.86 0 1.305.38 1.305 1.053v.55l-1.726.1c-1.516.093-2.37.754-2.37 1.901 0 1.164.895 1.908 2.124 1.908zm7.643 0c.878 0 1.62-.416 2.001-1.112h.1v1.006h1.205V6.678h-1.258v3.5h-.094c-.345-.703-1.082-1.118-1.954-1.118-1.609 0-2.645 1.275-2.645 3.288 0 2.019 1.024 3.295 2.645 3.295zm.357-5.454c1.053 0 1.714.837 1.714 2.165 0 1.334-.655 2.16-1.714 2.16-1.065 0-1.703-.814-1.703-2.166 0-1.34.644-2.159 1.703-2.159zm11.4 4.353c-1.094 0-1.708-.801-1.708-2.194 0-1.38.614-2.188 1.709-2.188 1.088 0 1.708.807 1.708 2.188 0 1.387-.62 2.194-1.708 2.194zm0 1.118c1.861 0 3.002-1.246 3.002-3.312 0-2.054-1.146-3.306-3.001-3.306-1.861 0-3.008 1.252-3.008 3.306 0 2.066 1.141 3.312 3.008 3.312zm4.812-.123h1.258V11.81c0-.995.62-1.615 1.632-1.615.936 0 1.393.509 1.393 1.533v3.81h1.258v-4.126c0-1.515-.802-2.37-2.224-2.37-.96 0-1.702.427-2.013 1.135h-.093V9.165H126.1v6.372zM137.73 7.62v1.574h-1.048v1.06h1.048v3.598c0 1.229.555 1.72 1.954 1.72.246 0 .474-.029.673-.064V14.46c-.176.017-.275.029-.468.029-.626 0-.901-.293-.901-.96v-3.277h1.427V9.194h-1.427V7.62h-1.258zm4.477 7.917h1.258v-3.721c0-.966.638-1.615 1.668-1.615.947 0 1.421.515 1.421 1.533v3.803h1.258v-4.113c0-1.516-.819-2.376-2.252-2.376-.96 0-1.697.427-2.007 1.141h-.1V6.68h-1.246v8.858zm10.294-5.424c.93 0 1.538.65 1.568 1.65h-3.219c.07-.995.72-1.65 1.65-1.65zm1.562 3.704c-.234.497-.755.772-1.516.772-1.006 0-1.656-.708-1.697-1.825v-.07h4.5v-.44c0-2-1.07-3.212-2.844-3.212-1.796 0-2.937 1.293-2.937 3.33 0 2.036 1.118 3.288 2.943 3.288 1.457 0 2.475-.702 2.762-1.843h-1.211z",
    fill: "#FFF"
  }), _react["default"].createElement("g", {
    fill: "#FFF"
  }, _react["default"].createElement("path", {
    d: "M37.747 25.07c-.038-4.285 3.51-6.37 3.672-6.468-2.01-2.93-5.124-3.33-6.218-3.361-2.616-.276-5.153 1.565-6.486 1.565-1.359 0-3.41-1.539-5.622-1.493-2.846.043-5.508 1.691-6.968 4.25-3.013 5.216-.766 12.883 2.121 17.1 1.444 2.066 3.132 4.37 5.34 4.29 2.161-.088 2.969-1.378 5.576-1.378 2.584 0 3.342 1.377 5.595 1.324 2.319-.034 3.779-2.073 5.173-4.158 1.669-2.365 2.339-4.698 2.365-4.818-.053-.017-4.502-1.715-4.548-6.852M33.492 12.467c1.162-1.454 1.958-3.431 1.737-5.438-1.682.075-3.786 1.164-4.998 2.585-1.071 1.253-2.029 3.306-1.781 5.237 1.89.141 3.83-.953 5.042-2.384"
  }))));
};

AppStoreIcon.defaultProps = {
  width: "172",
  height: "50",
  viewBox: "0 0 172 50",
  xmlns: "http://www.w3.org/2000/svg"
};

var GooglePlayIcon = function GooglePlayIcon(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("title", null, "Playstore"), _react["default"].createElement("defs", null, _react["default"].createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "38.913%",
    id: "b"
  }, _react["default"].createElement("stop", {
    stopColor: "#FBDA09",
    offset: "0%"
  }), _react["default"].createElement("stop", {
    stopColor: "#FFBC00",
    offset: "100%"
  })), _react["default"].createElement("path", {
    d: "M28.354 14.689c1.77 1.006 1.77 2.638 0 3.645L3.228 32.625C1.458 33.632.023 32.8.023 30.763V2.26C.023.225 1.458-.609 3.228.398l25.126 14.29z",
    id: "a"
  }), _react["default"].createElement("linearGradient", {
    x1: "0%",
    y1: "58.476%",
    x2: "69.306%",
    y2: "39.083%",
    id: "c"
  }, _react["default"].createElement("stop", {
    stopColor: "#01E2FF",
    offset: "0%"
  }), _react["default"].createElement("stop", {
    stopColor: "#01C4FF",
    offset: "100%"
  })), _react["default"].createElement("linearGradient", {
    x1: "20.281%",
    y1: "20.102%",
    x2: "83.82%",
    y2: "83.621%",
    id: "e"
  }, _react["default"].createElement("stop", {
    stopColor: "#28D781",
    offset: "0%"
  }), _react["default"].createElement("stop", {
    stopColor: "#02F076",
    offset: "100%"
  })), _react["default"].createElement("linearGradient", {
    x1: "74.488%",
    y1: "17.43%",
    x2: "10.108%",
    y2: "91.184%",
    id: "f"
  }, _react["default"].createElement("stop", {
    stopColor: "#F2414E",
    offset: "0%"
  }), _react["default"].createElement("stop", {
    stopColor: "#E02554",
    offset: "100%"
  }))), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M.17 4.852V44.54a4.681 4.681 0 0 0 4.682 4.681h162.296a4.682 4.682 0 0 0 4.682-4.681V4.85a4.681 4.681 0 0 0-4.682-4.68H4.852A4.682 4.682 0 0 0 .17 4.85z",
    fill: "#000",
    fillRule: "nonzero"
  }), _react["default"].createElement("g", {
    fill: "#FFF"
  }, _react["default"].createElement("path", {
    d: "M91.207 16.084a4.213 4.213 0 1 1 0-8.425 4.213 4.213 0 0 1 0 8.425zm0-1.287a2.925 2.925 0 1 0 0-5.85 2.925 2.925 0 0 0 0 5.85zM62.656 12.34v2.574h3.393v.936h-4.68V8.01h4.68v.936h-3.393v2.457h3.042v.937h-3.042zM70.613 8.946v6.904h-1.288V8.946h-1.989V8.01h5.266v.936h-1.99zM82.08 8.946v6.904h-1.287V8.946h-1.99V8.01h5.266v.936H82.08zM76.346 8.01h1.287v7.84h-1.287zM97.233 8.01h-.76v7.84h1.287V9.731l3.744 6.119h1.288V8.01h-1.288v5.737l-3.51-5.737h-.76zM59.376 8.916c-.686-.723-1.69-1.14-2.883-1.14a4.133 4.133 0 0 0-4.135 4.13 4.135 4.135 0 0 0 4.135 4.13c2.322.022 4.258-1.614 3.871-4.454v-.042h-1.03c.009.119.012.241.01.366.002 2.029-1.168 2.98-2.816 2.98a2.982 2.982 0 0 1-2.983-2.98 2.982 2.982 0 0 1 2.983-2.98c.824 0 1.539.282 2.042.796l.806-.806z"
  })), _react["default"].createElement("g", {
    fill: "#FFF"
  }, _react["default"].createElement("path", {
    d: "M125.375 22.052h6.634s3.82.65 3.82 5.035-3.82 5.035-3.82 5.035h-6.634v-10.07zm1.287 2.436v5.404h4.504s2.05 0 2.05-2.702-2.05-2.702-2.05-2.702h-4.504z"
  }), _react["default"].createElement("path", {
    d: "M124.79 22.052h2.34v16.382h-2.34zM137.193 22.052h2.34v16.382h-2.34zM148.208 37.262c-.645.532-1.675 1.033-3.303 1.135-3.729.232-3.73-3.17-3.73-3.4 0-.23-.185-3.004 2.782-3.445 2.1-.313 3.571.208 4.251.538v-.481c-.167-.637-.684-1.809-2.235-1.809-2.131 0-2.602 1.152-2.602 1.152l-1.949-1.152s1.09-2.249 4.364-2.249c4.07 0 4.763 2.808 4.763 3.753V38.428h-2.341v-1.166zm-.167-3.508s-4.509-1.216-4.666 1.317c-.156 2.533 4.326 1.317 4.726-.479 0-.57-.06-.838-.06-.838zM154.94 37.812l-2.183 5.185h2.34l6.331-15.038h-2.34l-2.978 7.074-3.002-7.13h-2.34l4.172 9.91zM119.55 31.732l-7.4 3.059s.477 1.692 2.703 1.703c1.742.009 2.726-1.545 2.726-1.545l1.878 1.272s-1.516 2.451-4.62 2.451c-3.813 0-5.493-3.335-5.493-5.5 0-2.087 1.334-5.62 5.257-5.62 3.924 0 4.95 4.18 4.95 4.18zm-2.815-.867s-.931-1.417-2.36-1.155c-3.02.552-2.64 3.196-2.64 3.196l5-2.04zM105.834 22.052h2.476V38.4h-2.476zM101.872 27.907l2.288.02V38.24c0 2.636-1.569 5.418-5.262 5.418-3.694 0-4.887-3.273-4.887-3.273l2.102-.884s.64 2.017 2.894 2.017c2.566 0 2.865-2.334 2.865-3.133v-1.12s-.888 1.39-3.093 1.39c-2.39 0-5.232-2.049-5.232-5.54 0-3.493 2.676-5.49 5.26-5.563 2.07-.058 3.065 1.374 3.065 1.374v-1.02zm-2.897 8.653c1.669 0 3.022-1.53 3.022-3.415 0-1.886-1.353-3.415-3.022-3.415-1.67 0-3.022 1.529-3.022 3.415 0 1.886 1.353 3.415 3.022 3.415zM86.949 38.668a5.564 5.564 0 0 1-5.571-5.558 5.564 5.564 0 0 1 5.57-5.559 5.564 5.564 0 0 1 5.571 5.559 5.564 5.564 0 0 1-5.57 5.558zm-.037-2.18c1.73 0 3.132-1.512 3.132-3.378s-1.402-3.379-3.132-3.379c-1.73 0-3.131 1.513-3.131 3.379s1.402 3.378 3.131 3.378zM74.896 38.668a5.564 5.564 0 0 1-5.57-5.558 5.564 5.564 0 0 1 5.57-5.559 5.564 5.564 0 0 1 5.57 5.559 5.564 5.564 0 0 1-5.57 5.558zm-.036-2.18c1.73 0 3.131-1.512 3.131-3.378S76.59 29.73 74.86 29.73c-1.73 0-3.131 1.513-3.131 3.379s1.401 3.378 3.13 3.378z"
  }), _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M60.512 29.314h7.355l-.073 2.325h-7.282z"
  }), _react["default"].createElement("path", {
    d: "M66.42 23.843c-1.432-1.508-3.526-2.376-6.017-2.376-4.766 0-8.63 3.854-8.63 8.61 0 4.754 3.864 8.602 8.63 8.61 4.845.043 8.886-3.366 8.078-9.287v-.086h-2.149c.018.247.024.501.018.762.005 4.23-2.436 6.212-5.875 6.212-3.438 0-6.226-2.78-6.226-6.212 0-3.43 2.788-6.212 6.226-6.212 1.72 0 3.212.587 4.261 1.658l1.683-1.679z"
  }))), _react["default"].createElement("g", {
    transform: "translate(11.755 8.127)"
  }, _react["default"].createElement("mask", {
    id: "d",
    fill: "#fff"
  }, _react["default"].createElement("use", {
    xlinkHref: "#a"
  })), _react["default"].createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  }), _react["default"].createElement("path", {
    fill: "url(#c)",
    mask: "url(#d)",
    d: "M0-.012l16.357 16.258-16.568 16.9z"
  }), _react["default"].createElement("path", {
    fill: "url(#e)",
    mask: "url(#d)",
    d: "M-3.364-3.358l19.72 19.609 5.862-5.593z"
  }), _react["default"].createElement("path", {
    fill: "url(#f)",
    mask: "url(#d)",
    d: "M16.358 16.247l8.975 9.046L-1.48 34.34z"
  }))));
};

GooglePlayIcon.defaultProps = {
  width: "172",
  height: "50",
  viewBox: "0 0 172 50",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};

var AndroidDownloadIcon = function AndroidDownloadIcon(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("title", null, "android"), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M172 44.328c0 3.133-2.794 5.672-6.24 5.672H6.24c-1.654 0-3.242-.598-4.412-1.661C.658 47.275 0 45.832 0 44.329V5.671C0 2.539 2.794 0 6.24 0h159.52c3.446 0 6.24 2.54 6.24 5.672v38.656",
    fill: "#100F0D",
    fillRule: "nonzero"
  }), _react["default"].createElement("text", {
    fill: "#FFF",
    fontFamily: "Arial-BoldMT, Arial",
    fontSize: "23.441",
    fontWeight: "bold"
  }, _react["default"].createElement("tspan", {
    x: "63.624",
    y: "42.135"
  }, "Android")), _react["default"].createElement("text", {
    fill: "#FFF",
    fillRule: "nonzero",
    fontFamily: "ArialMT, Arial",
    fontSize: "11.721"
  }, _react["default"].createElement("tspan", {
    x: "64",
    y: "19"
  }, "Download for")), _react["default"].createElement("g", {
    fill: "#9FC732",
    fillRule: "nonzero"
  }, _react["default"].createElement("path", {
    d: "M40.48 18.031H20.153a.818.818 0 0 0-.818.817v17.01c0 .45.366.816.818.816h3.625v5.732c0 1.33 1.08 2.409 2.413 2.409a2.411 2.411 0 0 0 2.414-2.409v-5.732h3.376v5.732c0 1.33 1.08 2.409 2.413 2.409a2.41 2.41 0 0 0 2.414-2.409v-5.732h3.674a.82.82 0 0 0 .819-.817V18.848a.818.818 0 0 0-.82-.817m-24.588-.004a2.411 2.411 0 0 0-2.413 2.408v9.782a2.41 2.41 0 0 0 2.413 2.408 2.41 2.41 0 0 0 2.414-2.408v-9.782a2.41 2.41 0 0 0-2.414-2.408M44.877 17.66c-1.33 0-2.41 1.091-2.41 2.436v9.895c0 1.345 1.08 2.436 2.41 2.436s2.41-1.09 2.41-2.436v-9.895c0-1.345-1.08-2.436-2.41-2.436m-19.441-6.768a.924.924 0 0 1 .813.464.945.945 0 0 1 0 .945.924.924 0 0 1-.813.464.932.932 0 0 1-.913-.936c0-.512.406-.93.913-.937zm10.96.937a.939.939 0 0 1-.454.836.918.918 0 0 1-.944 0 .939.939 0 0 1-.454-.836.931.931 0 0 1 .926-.906c.5 0 .91.4.926.906zm-15.902 4.628h19.918c.52 0 .907-.483.8-.998a11.12 11.12 0 0 0-5.37-7.395l1.702-3.106a.44.44 0 0 0-.168-.592.426.426 0 0 0-.585.17l-1.716 3.129a10.856 10.856 0 0 0-4.622-1.027 10.854 10.854 0 0 0-4.622 1.027l-1.716-3.13a.428.428 0 0 0-.58-.16.438.438 0 0 0-.173.582l1.702 3.107a11.123 11.123 0 0 0-5.37 7.395.825.825 0 0 0 .8.998"
  }))));
};

AndroidDownloadIcon.defaultProps = {
  width: "172",
  height: "50",
  viewBox: "0 0 172 50",
  xmlns: "http://www.w3.org/2000/svg"
};

function WalletDownload(props) {
  var browser = (0, _useBrowser["default"])();
  var newProps = (0, _Util.mergeProps)(props, WalletDownload, ['style']);

  var title = newProps.title,
      children = newProps.children,
      iosLink = newProps.iosLink,
      androidLink = newProps.androidLink,
      androidDownLoadUrl = newProps.androidDownLoadUrl,
      locale = newProps.locale,
      rest = _objectWithoutProperties(newProps, ["title", "children", "iosLink", "androidLink", "androidDownLoadUrl", "locale"]);

  var isAndroid = browser.mobile.android.phone || browser.mobile.android.tablet;
  var isIOS = browser.mobile.apple.phone || browser.mobile.apple.tablet;
  return _react["default"].createElement(Container, rest, _react["default"].createElement("div", {
    className: "download-text"
  }, !!title && _react["default"].createElement(_Typography["default"], {
    className: "download-title",
    component: "div"
  }, title), children && _react["default"].createElement(_Typography["default"], {
    className: "download-extra",
    component: "div"
  }, children)), !browser.mobile.any && _react["default"].createElement("div", {
    className: "download-store-list"
  }, _react["default"].createElement(_Button["default"], {
    className: "download-link",
    component: "a",
    href: iosLink
  }, _react["default"].createElement(AppStoreIcon, null)), locale === 'zh' && _react["default"].createElement(_Button["default"], {
    component: "a",
    className: "download-link",
    href: androidDownLoadUrl
  }, _react["default"].createElement(AndroidDownloadIcon, null)), locale === 'en' && _react["default"].createElement(_Button["default"], {
    component: "a",
    className: "download-link",
    href: androidLink
  }, _react["default"].createElement(GooglePlayIcon, null))), isAndroid && _react["default"].createElement("div", {
    className: "download-store-list"
  }, locale === 'zh' && _react["default"].createElement(_Button["default"], {
    component: "a",
    href: androidDownLoadUrl,
    variant: "outlined",
    color: "primary"
  }, "\u672C\u5730\u4E0B\u8F7D"), locale === 'en' && _react["default"].createElement(_Button["default"], {
    component: "a",
    href: androidLink,
    variant: "outlined",
    color: "primary"
  }, "Download")), isIOS && _react["default"].createElement("div", {
    className: "download-store-list"
  }, _react["default"].createElement(_Button["default"], {
    component: "a",
    href: iosLink,
    variant: "outlined",
    color: "primary"
  }, "Download")));
}

WalletDownload.propTypes = {
  title: _propTypes["default"].string,
  layout: _propTypes["default"].oneOf(['vertical', 'horizontal']),
  storeLayout: _propTypes["default"].oneOf(['vertical', 'horizontal']),
  style: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  iosLink: _propTypes["default"].string,
  androidLink: _propTypes["default"].string,
  androidDownLoadUrl: _propTypes["default"].string,
  locale: _propTypes["default"].oneOf(['en', 'zh'])
};
WalletDownload.defaultProps = {
  title: 'Download ABT Wallet',
  layout: 'vertical',
  storeLayout: 'horizontal',
  iosLink: 'https://itunes.apple.com/app/id1460083542',
  androidLink: 'https://play.google.com/store/apps/details?id=com.arcblock.wallet.app.product',
  androidDownLoadUrl: 'http://releases.arcblockio.cn/arcwallet_android/latest/abtwallet.apk',
  style: {},
  locale: 'zh'
};

var Container = _styledComponents["default"].div.withConfig({
  displayName: "Download__Container",
  componentId: "dufrvq-0"
})(["display:flex;flex-direction:", ";align-items:center;.download-title{margin-right:", ";margin-bottom:", ";}.download-store-list{display:flex;flex-direction:", ";justify-content:space-between;align-items:center;.download-link{padding:0;margin:0;margin-right:", ";margin-bottom:", ";&:last-of-type{margin-right:0;margin-bottom:0;}}}"], function (props) {
  return props.layout === 'vertical' ? 'column' : 'row';
}, function (props) {
  return props.layout === 'vertical' ? '0' : '16px';
}, function (props) {
  return props.layout === 'vertical' ? '16px' : '0';
}, function (props) {
  return props.storeLayout === 'vertical' ? 'column' : 'row';
}, function (props) {
  return props.storeLayout === 'vertical' ? '0' : '16px';
}, function (props) {
  return props.storeLayout === 'vertical' ? '16px' : '0';
});